import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'

export const mocker = {
  calendarMain (year) {
    const mockYear = year
    let mockMonths = []
    let mockDays = []
    let sumDayInMonth = 0
    for (var i = 0; i <= 11; i++) {
      sumDayInMonth = moment(moment().format(mockYear + '-' + _.padStart(i + 1, 2, '0') + '-01')).daysInMonth()
      mockDays = []
      for (var j = 1; j <= sumDayInMonth; j++) {
        mockDays.push({
          tab1: false,
          tab2: false,
          tab3: false,
          tab4: false
        })
      }
      mockMonths.push(mockDays)
    }
    return {
      year: mockYear,
      month: mockMonths
    }
  },
  calendar (year) {
    let calendarTab1 = calendarTab1(year)
    let calendarTab2 = calendarTab2(year)
    let calendarTab3 = calendarTab3(year)
    let calendarTab4 = calendarTab4(year)
    let calendarHoliday = {}
    return {
      calendarTab1: calendarTab1,
      calendarTab2: calendarTab2,
      calendarTab3: calendarTab3,
      calendarTab4: calendarTab4,
      calendarHoliday: calendarHoliday
    }
  },
  calendarTab1 (year) {
    let mockFullDate = new Date(year, 0, 1)
    let mockDate = 0
    let mockMonth = 0
    let mockYear = 0
    const mockAmountPercent = 0.1
    const mockTotalDayInYear = 366
    let CalendarTab1 = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    for (var i = 1; i < mockTotalDayInYear; i++) {
      mockDate = mockFullDate.getDate()
      mockMonth = mockFullDate.getMonth() + 1
      mockYear = mockFullDate.getFullYear()
      if (Math.random() < mockAmountPercent) {
        staappr = mockStaappr[Math.floor(Math.random() * 5)]
        CalendarTab1.push({
          date: mockDate,
          month: mockMonth,
          year: mockYear,
          staappr: staappr,
          dtereq: _.padStart(mockDate, 2, '0') + '/' + _.padStart(mockMonth, 2, '0') + '/' + mockYear,
          status: mockStatus[staappr],
          descType: faker.system.commonFileType(),
          timstrt: faker.date.past().toString().substr(16, 5),
          timend: faker.date.future().toString().substr(16, 5),
          dtestrt: moment('DD/MM/YYYY'),
          dteend: moment('DD/MM/YYYY'),
          descDetail: faker.lorem.sentence(),
          remark: mockStatus[staappr]
        })
      }
      mockFullDate.setDate(mockFullDate.getDate() + 1)
    }
    return {
      total: CalendarTab1.length,
      rows: CalendarTab1
    }
  },
  calendarTab2 (year) {
    let mockFullDate = new Date(year, 0, 1)
    let mockDate = 0
    let mockMonth = 0
    let mockYear = 0
    const mockAmountPercent = 0.1
    const mockTotalDayInYear = 366
    let CalendarTab2 = []
    for (var i = 1; i < mockTotalDayInYear; i++) {
      mockDate = mockFullDate.getDate()
      mockMonth = mockFullDate.getMonth() + 1
      mockYear = mockFullDate.getFullYear()
      if (Math.random() < mockAmountPercent) {
        CalendarTab2.push({
          date: mockDate,
          month: mockMonth,
          year: mockYear,
          descTime: faker.date.past().toString().substr(15, 6) + ' - ' + faker.date.future().toString().substr(15, 6),
          place: faker.address.streetAddress(),
          descDetail: faker.lorem.sentence()
        })
      }
      mockFullDate.setDate(mockFullDate.getDate() + 1)
    }
    return {
      total: CalendarTab2.length,
      rows: CalendarTab2
    }
  },
  calendarTab3 (year) {
    let mockFullDate = new Date(year, 0, 1)
    let mockDate = 0
    let mockMonth = 0
    let mockYear = 0
    const mockAmountPercent = 0.1
    const mockTotalDayInYear = 366
    let CalendarTab3 = []
    for (var i = 1; i < mockTotalDayInYear; i++) {
      mockDate = mockFullDate.getDate()
      mockMonth = mockFullDate.getMonth() + 1
      mockYear = mockFullDate.getFullYear()
      if (Math.random() < mockAmountPercent) {
        CalendarTab3.push({
          date: mockDate,
          month: mockMonth,
          year: mockYear,
          title: faker.lorem.words(),
          timestr: faker.date.past().toString().substr(16, 5),
          timeend: faker.date.past().toString().substr(16, 5),
          place: faker.address.streetAddress()
        })
      }
      mockFullDate.setDate(mockFullDate.getDate() + 1)
    }
    return {
      total: CalendarTab3.length,
      rows: CalendarTab3
    }
  },
  calendarTab4 (year) {
    let mockFullDate = new Date(year, 0, 1)
    let mockDate = 0
    let mockMonth = 0
    let mockYear = 0
    const mockAmountPercent = 0 // 0.1
    const mockTotalDayInYear = 366
    let CalendarTab4 = []
    for (var i = 1; i < mockTotalDayInYear; i++) {
      mockDate = mockFullDate.getDate()
      mockMonth = mockFullDate.getMonth() + 1
      mockYear = mockFullDate.getFullYear()
      if (Math.random() < mockAmountPercent) {
        CalendarTab4.push({
          id: i - 1,
          date: mockDate,
          month: mockMonth,
          year: mockYear,
          numseq: 1,
          topic: faker.lorem.words(),
          timstrt: faker.date.past().toString().substr(16, 5),
          timend: faker.date.past().toString().substr(16, 5),
          checked: (Math.random() < 0.5) ? 'Y' : 'N',
          place: faker.address.streetAddress()
        })
      }
      mockFullDate.setDate(mockFullDate.getDate() + 1)
    }
    return {
      total: CalendarTab4.length,
      rows: CalendarTab4
    }
  },
  postCalendarTab4Checked () {
    return {
      status: 'success',
      data: {
        response: ''
      }
    }
  },
  postCalendarTab4 () {
    return {
      status: 'success',
      data: {
        response: '',
        numseq: 1
      }
    }
  },
  deleteCalendarTab4 () {
    return {
      status: 'success',
      data: {
        response: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/calendar/mocker.js